<script setup lang="ts">
type Props =
  | {
      name: keyof typeof iconPackMapper;
      hardCodedIcon?: undefined;
      size?: number;
      alt?: string;
    }
  | {
      hardCodedIcon: string;
      name?: undefined;
      size?: number;
      alt?: string;
    };

const props = defineProps<Props>();

const iconName = computed(() => {
  if (props.hardCodedIcon) return props.hardCodedIcon;

  return iconPackMapper[props.name ?? "spinner"];
});
</script>

<template>
  <span class="flex items-center justify-center">
    <Icon
      v-if="!hardCodedIcon"
      :size="size ?? 16"
      class="icon"
      :name="iconName"
    />
    <Suspense v-else>
      <ClientOnly>
        <Icon
          :size="size ?? 16"
          class="icon"
          :name="iconName"
        />
        <template #placeholder>
          <BaseSkeletonLoader
            :width="size ?? 16"
            :height="size ?? 16"
          />
        </template>
      </ClientOnly>
    </Suspense>
    <span
      v-if="alt"
      class="sr-only"
    >
      {{ alt }}
    </span>
  </span>
</template>

<style lang="postcss" scoped>
.icon {
  @apply inline-block;
  vertical-align: -0.1rem;
}
</style>
